import { managePartnerTabRoutes } from '@atlassian/mpac-utils';
import { NEW_REPORTS_EAP_ROLLOUT_PARTNER_IDS } from "../constants/Partners";
import { getReportsRouteLink } from "../utils/routeUtils";
export const TabNames = {
  APPS: 'Apps',
  DETAILS: 'Details',
  CONTACTS: 'Contacts',
  PROMOTIONS: 'Promotions',
  SECURITY: 'Security',
  REPORTS: 'Reports',
  ADMIN: 'Admin',
  PAYMENT_INFO: 'Payment',
  AUDIT_LOGS: 'Audit logs'
};
export const isNewReportsRolledOut = partnerId => NEW_REPORTS_EAP_ROLLOUT_PARTNER_IDS.includes(partnerId);
export const getTabs = (partnerId, permissions, displayAuditTabInManagePartnerPage, spaNavigateReports = false) => {
  const links = managePartnerTabRoutes();
  return [...(permissions.canViewManagedApps ? [{
    href: links.apps.expand({
      partnerId
    }),
    text: TabNames.APPS,
    renderSPARoute: true
  }] : []), ...(permissions.canManagePartnerDetails ? [{
    href: links.details.expand({
      partnerId
    }),
    text: TabNames.DETAILS,
    renderSPARoute: true
  }] : []), ...(permissions.canViewPartnerContacts ? [{
    href: links.contacts.expand({
      partnerId
    }),
    text: TabNames.CONTACTS,
    renderSPARoute: true
  }] : []), ...(permissions.canViewPartnerPaymentDetails ? [{
    href: links.payment.expand({
      partnerId
    }),
    text: TabNames.PAYMENT_INFO,
    renderSPARoute: true
  }] : []), ...(permissions.canManagePromotions ? [{
    href: links.promotions.expand({
      partnerId
    }),
    text: TabNames.PROMOTIONS,
    renderSPARoute: true
  }] : []), ...(permissions.canManagePartnerSecurity ? [{
    href: links.security.expand({
      partnerId
    }),
    text: TabNames.SECURITY,
    renderSPARoute: true
  }] : []), ...(permissions.canViewAnyReports ? [{
    href: getReportsRouteLink(partnerId, permissions.canViewSalesReport),
    text: TabNames.REPORTS,
    renderSPARoute: spaNavigateReports
  }] : []), ...(permissions.isSiteAdmin ? [{
    href: links.admin.expand({
      partnerId
    }),
    text: TabNames.ADMIN,
    renderSPARoute: true
  }] : []), ...(displayAuditTabInManagePartnerPage && permissions.isSiteAdmin ? [{
    href: links.audit.expand({
      partnerId
    }),
    text: TabNames.AUDIT_LOGS,
    renderSPARoute: true
  }] : [])];
};